export default {
  data() {
    return {
      showPlanDetail: true,
    }
  },
}
